export const features = {
  PermitirPagamentoRateado: true,
};
